export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const SAVE_SHIPPING_INFO = "SAVE_SHIPPING_INFO";


export const ADD_TO_ORDER = "ADD_TO_ORDER";
export const RESET_ORDER = "RESET_ORDER";
// export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
// export const SAVE_SHIPPING_INFO = "SAVE_SHIPPING_INFO";


